module.exports = __webpack_public_path__ + "c92df54b739697afc73bbc92fe90fe30.png";